import { useEffect, useMemo, useState } from 'react';
import { useGetLobbyQuery, useGetEventQuery } from '@/store/api';
import { EventStatus } from '@sportspredict/shared';

interface UseLobbyClosedPopupProps {
	eventId: string | undefined;
	lobbyId: string | undefined;
	currentUserId: string | undefined;
	isAdmin: boolean;
}

export function useLobbyClosedPopup({
	eventId,
	lobbyId,
	currentUserId,
	isAdmin,
}: UseLobbyClosedPopupProps) {
	const [showLobbyClosedPopup, setShowLobbyClosedPopup] = useState(false);

	const { data: lobbyResponse } = useGetLobbyQuery(lobbyId!, { skip: !lobbyId });
	const { data: eventResponse } = useGetEventQuery(eventId!, { skip: !eventId });

	const hasCurrentUserJoinedLobby = useMemo(
		() => !!lobbyResponse?.lobby_users?.some((u: any) => u.user_id === currentUserId),
		[lobbyResponse?.lobby_users, currentUserId]
	);

	const isEventClosed = useMemo(() => {
		if (!eventResponse) return false;
		const now = new Date();
		return (
			eventResponse.status === EventStatus.Closed ||
			(eventResponse.end_date && new Date(eventResponse.end_date) <= now)
		);
	}, [eventResponse]);

	useEffect(() => {
		if (isEventClosed && !hasCurrentUserJoinedLobby && !isAdmin) {
			setShowLobbyClosedPopup(true);
		}
	}, [isEventClosed, hasCurrentUserJoinedLobby]);

	return {
		showLobbyClosedPopup,
		setShowLobbyClosedPopup,
	};
}
